import ApiService from '@/shared/services/api.service';

export class DecisionPurposeService {
    static list(params) {
        return new Promise((resolve, reject) => {
            ApiService.query('/decision-purposes', params)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static create(data) {
        return new Promise((resolve, reject) => {
            ApiService.post( '/decision-purposes?echo=true', { ...data } )
            .then((response) => resolve(response))
            .catch((error) => reject(error));
        });
    }

    static update(id, data) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/decision-purposes/${id}`, { ...data })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static async remove(id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/decision-purposes/${id}`)
                .then(() => resolve())
                .catch((error) => {
                    reject(error);
                });
        });
    }

    static async listAutocomplete() {
        const response = await ApiService.get('/decision-purposes');
        return response?.data?.data || [];
    }
}
